import { useState } from "react";
import { Box, Card, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, alpha } from "@mui/material";
import HandshakeIcon from '@mui/icons-material/Handshake';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import PreviewIcon from '@mui/icons-material/Preview';
import CloseIcon from '@mui/icons-material/Close';
import { CardContent, Typography } from "@mui/material";
import TeamPartnersMockup from "./TeamPartnersMockup";

export default function TeamPartners() {
  const [mockupOpen, setMockupOpen] = useState(false);

  return (
    <>
      {/* Team Partners - Coming Soon Section */}
      <Card 
        sx={{ 
          borderRadius: 3, 
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
          mt: 4,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
            color: 'white',
            px: 3,
            py: 1,
            borderBottomLeftRadius: 12,
            fontWeight: 700,
            fontSize: '0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            zIndex: 1,
          }}
        >
          <HourglassEmptyIcon sx={{ fontSize: 18 }} />
          COMING SOON
        </Box>
        <CardContent sx={{ pt: 5 }}>
          <Box display="flex" alignItems="center" gap={2} mb={3}>
            <HandshakeIcon sx={{ fontSize: 40, color: "text.disabled" }} />
            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 0.5, color: 'text.disabled' }}>
                Team Partners
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Collaborate with external partners and specialists
              </Typography>
            </Box>
          </Box>
  
          <Box 
            textAlign="center" 
            py={6}
            sx={{
              bgcolor: "background.default",
              borderRadius: 2,
              border: "2px dashed",
              borderColor: "divider",
            }}
          >
            <HandshakeIcon sx={{ fontSize: 80, color: "text.disabled", mb: 2 }} />
            <Typography variant="h6" color="text.secondary" gutterBottom>
              Partner Collaboration Feature
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={2} maxWidth="500px" mx="auto">
              Soon you'll be able to invite external partners, specialists, and collaborators to work 
              together on specific cases while maintaining secure access controls.
            </Typography>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                px: 3,
                py: 1.5,
                borderRadius: 2,
                bgcolor: 'rgba(245, 158, 11, 0.1)',
                border: '1px solid rgba(245, 158, 11, 0.3)',
                mt: 2,
              }}
            >
              <HourglassEmptyIcon sx={{ color: '#f59e0b', fontSize: 20 }} />
              <Typography 
                variant="body2" 
                sx={{ 
                  fontWeight: 600,
                  color: '#d97706',
                }}
              >
                Feature in Development
              </Typography>
            </Box>

            {/* Sneak Peek Button */}
            <Box mt={3}>
              <Button
                variant="contained"
                size="large"
                startIcon={<PreviewIcon />}
                onClick={() => setMockupOpen(true)}
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  bgcolor: alpha('#2563eb', 0.9),
                  background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                  boxShadow: '0 4px 14px rgba(37, 99, 235, 0.4)',
                  '&:hover': {
                    bgcolor: '#1d4ed8',
                    boxShadow: '0 6px 20px rgba(37, 99, 235, 0.5)',
                    transform: 'translateY(-2px)',
                  },
                  transition: 'all 0.3s',
                }}
              >
                🎉 Sneak Peek: View Mockup (Beta)
              </Button>
              <Typography variant="caption" display="block" color="text.secondary" mt={1.5}>
                Preview the GitHub-inspired collaboration interface
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* Mockup Preview Dialog */}
      <Dialog
        fullScreen
        open={mockupOpen}
        onClose={() => setMockupOpen(false)}
        sx={{
          '& .MuiDialog-paper': {
            bgcolor: 'background.default',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: 1,
            borderColor: 'divider',
            bgcolor: alpha('#2563eb', 0.05),
          }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <PreviewIcon sx={{ color: 'primary.main', fontSize: 32 }} />
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Team Partners
              </Typography>
              {/* <Typography variant="caption" color="text.secondary">
                Work in Progress 
              </Typography> */}
            </Box>
          </Box>
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setMockupOpen(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <TeamPartnersMockup />
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            py: 2,
            borderTop: 1,
            borderColor: 'divider',
            bgcolor: alpha('#000', 0.02),
          }}
        >
          <Button onClick={() => setMockupOpen(false)} variant="outlined" sx={{ textTransform: 'none' }}>
            Close Preview
          </Button>
          <Button
            variant="contained"
            sx={{
              textTransform: 'none',
              fontWeight: 600,
            }}
            disabled
          >
            Request Beta Access (Coming Soon)
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
